module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAMCAMAAACz+6aNAAAANlBMVEX///8AAAD///////////////////////////////////////////////////////////////9TvwflAAAAEnRSTlPMAKMLiXKdlI7Hgn5hVj80JhGSPRADAAAASElEQVQI12XIWw6AIAwF0Tu0CL51/5s1MUYLztfkyEqKTWhR26bSSVb9ydrJLoYGZoRFchBYioAI5NzyUeUVzKUxEwTOw567AHjSASim92hqAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/imgs/bottom.png
// module id = nk0+
// module chunks = 1